import React, { Component } from 'react';
import {Route, Routes} from 'react-router-dom';
import './App.css';
import Main from './components/Main'
import Physics from './components/Physics'
import CargoCultScience from './components/CargoCultScience'
import NavBar from './components/navBar';
import Footer from './components/Footer';
import GolangDetails from './components/GolangDetails';
import DockerAndK8sDetails from './components/DockerAndK8sDetails';
import DockerDetails from './components/DockerDetails';
import StrumiaDetails from './components/StrumiaDetails';
import ComplexNumberDetails from './components/ComplexNumbers';
import QuantumBitsDetails from './components/QuantumBitsDetails';
import BitsAndAllThat from './components/BitsAndAllThatDetails';
import FoleyRotation from './components/FoleyRotDetails';
import AngularDetails from './components/AngularDetails';
import OrionDetails from './components/OrionDetails';
import Magic from './components/MagicDetails';
import Casimir from './components/Casimir';
import Mossbauer from './components/Mossbauer';
import Christmas2025 from './components/Christmas2025';

class App extends Component {
  render() {
    return (
      <React.Fragment>
         <NavBar/>
      <div>
          <div className="content">
          <Routes>
              <Route path="/Golang" element={<GolangDetails />} />
              <Route path="/DockerKubernetes" element={<DockerAndK8sDetails />} />
              <Route path="/Docker" element={<DockerDetails />} />
              <Route path="/Strumia" element={<StrumiaDetails />} />
              <Route path="/ComplexNumbers" element={<ComplexNumberDetails />} />
              <Route path="/QuantumBits" element={<QuantumBitsDetails />} />
              <Route path="/BitsAndAllThat" element={<BitsAndAllThat />} />
              <Route path="/FoleyRotation" element={<FoleyRotation />} />
              <Route path="/Angular" element={<AngularDetails />} />
              <Route path="/Orion" element={<OrionDetails />} />
              <Route path="/Magic" element={<Magic />} />
              <Route path="/Physics" element={<Physics />} />
              <Route path="/CargoCultScience" element={<CargoCultScience />} />
              <Route path="/Casimir" element={<Casimir />} />
              <Route path="/Mossbauer" element={<Mossbauer />} />
              <Route path="/Christmas2025" element={<Christmas2025 />} />
              <Route path="/" element={<Main />} />
            </Routes>
          </div>
      </div>
      <Footer/>
      </React.Fragment>
     
    );
  }
}

export default App;
